import app from "../_app";

const nav = document.querySelector('.js-nav');

if(nav) {
    if(app.viewport.isSmallerThan('lg')) {
        const navItems = [...nav.querySelectorAll('.js-nav-item')];
        const backTriggers = [...nav.querySelectorAll('.js-nav-back')];
        const navTriggers = [...document.querySelectorAll('.js-nav-trigger')];

        const navItemClickHandler = (e) => {
            if(e.currentTarget.nextElementSibling){
                e.preventDefault();
                e.currentTarget.nextElementSibling.setAttribute('data-open', '');
            }
        };

        const backClickHandler = (e) => {
            e.currentTarget.closest('.js-nav-sub-nav').removeAttribute('data-open');
        };

        const triggerClickHandler = () => {
            if(nav.hasAttribute('data-open')) {
                const openSubNavs = [...nav.querySelectorAll('.js-nav-sub-nav[data-open]')];

                nav.removeAttribute('data-open');

                openSubNavs.map(openSubNav => openSubNav.removeAttribute('data-open'));

                app.unlockBody();
            } else {
                app.lockBody();
                nav.setAttribute('data-open', '');
            }
        };

        navItems.map(navItem => navItem.firstElementChild.addEventListener('click', navItemClickHandler));
        backTriggers.map(backTrigger => backTrigger.addEventListener('click', backClickHandler));
        navTriggers.map(navTrigger => navTrigger.addEventListener('click', triggerClickHandler));
    } else {
        const CATEGORY_SWITCH_DELAY = 120;

        const navTopItems = [...nav.querySelectorAll('.js-nav-top-item')];
        const navMoreItemsElement = nav.querySelector('.js-nav-more-items');
        const navMoreItems = [...nav.querySelectorAll('.js-nav-more-item')];

        const clearDepth2Panels = (megaMenu) => {
            megaMenu.querySelectorAll('.js-nav-sub-nav[data-depth="2"]').forEach(el => {
                el.removeAttribute('data-open');
            });
            megaMenu.removeAttribute('data-sub-switching');
        };

        const resetMegaMenu = (megaMenu) => {
            clearDepth2Panels(megaMenu);
            megaMenu._clearCategoryPanels?.();
        };

        nav.querySelectorAll('.js-nav-items[data-depth="0"] > .nav__item[data-subs]').forEach(item => {
            const megaMenu = item.querySelector('.js-nav-sub-nav[data-depth="1"]');
            if (!megaMenu) return;

            item.addEventListener('mouseleave', (e) => {
                const related = e.relatedTarget;
                if (related && item.contains(related)) return;
                resetMegaMenu(megaMenu);
            });
        });

        const setupCategorySwitchDelay = (megaMenu) => {
            const items = [...megaMenu.querySelectorAll('.nav__items[data-depth="1"] > .nav__item.js-nav-item')];
            let activeItem = null;
            let switchTimer = null;

            const getPanel = (item) => item.querySelector('.js-nav-sub-nav[data-depth="2"]');

            const clearSwitching = () => {
                clearTimeout(switchTimer);
                switchTimer = null;
                megaMenu.removeAttribute('data-sub-switching');
            };

            const clearPanels = () => {
                clearSwitching();
                megaMenu.querySelectorAll('.js-nav-sub-nav[data-depth="2"]').forEach(el => {
                    el.removeAttribute('data-open');
                });
                activeItem = null;
            };

            const activate = (item) => {
                const panel = getPanel(item);
                if (!panel) return;

                clearSwitching();

                if (activeItem && activeItem !== item) {
                    getPanel(activeItem)?.removeAttribute('data-open');
                }

                panel.setAttribute('data-open', '');
                activeItem = item;
            };

            const scheduleSwitch = (item) => {
                clearSwitching();
                megaMenu.setAttribute('data-sub-switching', '');

                switchTimer = setTimeout(() => {
                    switchTimer = null;
                    activate(item);
                }, CATEGORY_SWITCH_DELAY);
            };

            items.forEach(item => {
                const panel = getPanel(item);
                if (!panel) return;

                item.addEventListener('mouseenter', () => {
                    if (activeItem === item) return;

                    if (!activeItem) {
                        activate(item);
                        return;
                    }

                    scheduleSwitch(item);
                });

                item.addEventListener('mouseleave', (e) => {
                    if (!switchTimer) return;
                    if (!activeItem) return;

                    const related = e.relatedTarget;
                    const activePanel = getPanel(activeItem);

                    if (activePanel && (activePanel.contains(related) || activeItem.contains(related))) {
                        clearSwitching();
                    }
                });

                panel.addEventListener('mouseenter', () => {
                    activate(item);
                });
            });

            megaMenu._clearCategoryPanels = clearPanels;
        };

        nav.querySelectorAll('.js-nav-sub-nav[data-depth="1"]').forEach(setupCategorySwitchDelay);

        nav.addEventListener('mouseleave', (e) => {
            if (nav.contains(e.relatedTarget)) return;

            nav.querySelectorAll('.js-nav-sub-nav[data-depth="1"]').forEach(resetMegaMenu);
        });

        const handleNavSize = (size) => {
            let itemsWidth = 0;
            let fitIndex = 0;

            navTopItems.map(item => {
                item.classList.remove('d-none');
                itemsWidth += item.clientWidth;

                if((itemsWidth + ((fitIndex + 1) * 32)) < size) {
                    fitIndex++;
                } else {
                    item.classList.add('d-none');
                }
            });

            if(fitIndex < navTopItems.length) {
                navTopItems?.[fitIndex - 1]?.classList.add('d-none');
                navMoreItemsElement.classList.remove('d-none');
            } else {
                navMoreItemsElement.classList.add('d-none');
            }

            navMoreItems.map((item, index) => {
                if(index >= fitIndex - 1) {
                    item.classList.remove('d-none');
                } else {
                    item.classList.add('d-none');
                }
            });
        };


    }

    nav.removeAttribute('data-loading');
}
